import { ApiConfig } from "common/models";
import { CONTROLLER } from "common/config/endpoint.config";
import { buildGdxApiUrl } from "common/utils/api.util";
import {
  ExtractionRequestBody,
  DocumentSavePayload
} from "../models/document-extraction.model";

export const documentExtractionConfig = {
  /**
   * Extract document using specified model endpoint
   */
  extractDocument: (
    endpoint: string,
    requestBody: ExtractionRequestBody
  ): ApiConfig =>
    new ApiConfig(
      `${endpoint}`, // Use the endpoint as-is since it may be a function app URL
      "POST",
      undefined,
      requestBody
    ),

  /**
   * Save document configuration and extracted data
   */
  saveDocument: (
    payload: DocumentSavePayload,
    flowId: string | number,
    docId: string | number
  ): ApiConfig =>
    new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/extracted-data/upsert/${flowId}/${docId}`
      ),
      "POST",
      undefined,
      payload // Send items array directly
    )
};
